module.exports = __webpack_public_path__ + "img/arrow.26039806.svg";